<template>
    <div class="input { 'error' : state === 'error' }" :class="inputClass">
        <label :for="inputId">
            {{ labelText }}
            <span v-if="important">*</span>
        </label>
        <div class="input-wrapper">
            <textarea :id="inputId" :name="inputName" :value="inputValue" :placeholder="placeholder"   @input="handleInput($event)" :disabled="disabled" :readonly="readonly" />
        </div>
    </div>
</template>

<script>
export default {
    name: "TextareaBox",
    props     : {
        inputId       : String,
        inputName     : String,
        inputValue    : String,
        placeholder   : String,
        labelText     : String,
        important     : Boolean,
        disabled      : Boolean,
        readonly      : Boolean,
    },
    computed: {
        inputClass() {
            return {
                'error-state'   : this.state === 'error',
                'disabled-state': this.state === 'disabled',
                'readonly-state': this.state === 'readOnly',
                'small'         : this.style === 'small',
                'regular'       : this.style === 'regular',
                'medium'        : this.style === 'medium',
            }
        }
    },

    methods : {
        handleInput(event) {
            this.$emit('input', event);
        },
    }
}
</script>

<style lang="scss" scoped>
.input {
    display: block;
    position: relative;
    width: 100%;

    &.small {
        width: 140px;
    }

    &.regular {
        width: 200px;
    }

    &.medium {
        width: 460px;
    }

    label {
        position: absolute;
        font-size: $font11;
        font-weight: 400;
        color: $text-color-lv-3;
        z-index: 1;
        background-color: $bk-color-lv-3;
        left: 14px;
        top: -8px;

        span{
            color: $red-color-lv-2;
        }
    }

    &-wrapper {
        position: relative;
        width: 100%;

        img {
            @include my-auto;
            left: 10px;
            width: 20px;
            height: 20px;
        }

        textarea {
            border-radius: 4px;
            width: 100%;
            height: 170px;
            padding: 10px 14px;
            font-size: $font14;
            font-weight: 400;
            background-color: $bk-color-lv-3;
            border: 1px solid $line-color-lv-2;
            resize: none;

            &:read-only {
                background-color: $table-color-lv-1;
            }
        }
    }

    p {
        display: none;

        span {
            display: none;
        }

        &.helper {
            color: $text-color-lv-5;
            font-size: $font12;
            font-weight: 400;
            display: block;
        }
    }

    &.error {
        input {
            border: 1px solid $red-color-lv-2;
        }

        p {
            span {
                display: inline;
            }

            &.helper {
                color: $red-color-lv-2;
            }
        }
    }
}
</style>